<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
      <div class="main-navbar logo">
        <nav class="navbar align-items-stretch navbar-light bg-primary flex-md-nowrap border-bottom p-0">
          <a class="navbar-brand w-100 h-100 mr-0" href="#" style="line-height: 25px;">
            <div class="d-table m-auto d-flex text-center align-items-center justify-content-center">
              <img id="logo-image" class="d-inline-block align-top mr-1" style="max-height: 38px; max-width: 25%" src="@/assets/images/logo_image.png" alt="Shards Dashboard">
              <img id="logo-text" class="d-inline-block align-top mr-1" style="max-height: 38px; max-width: 70%" src="@/assets/images/logo_text.png" alt="Shards Dashboard">
            </div>
          </a>
          <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none text-white" @click="handleToggleSidebar()">
            <i class="material-icons">&#xE5C4;</i>
          </a>
        </nav>
      </div>

      <div class="nav-wrapper">
          <d-nav class="flex-column">
            <li v-for="(item, navItemIdx) in items" :key="navItemIdx" class="nav-item dropdown">
              <d-link :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navItemIdx}`" @click="handleToggleSidebar()">
                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                <span v-if="item.title">{{ item.title }}</span>
                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
              </d-link>
              <d-collapse v-if="item.items && item.items.length" :id="`snc-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                <d-link class="dropdown-item nav-link" v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :to="subItem.to" @click="handleToggleSidebar()">
                  {{ subItem.title }}
                </d-link>
              </d-collapse>
            </li>
          </d-nav>
      </div>
  </aside>
</template>

<script>
import Events from '_utils/events';

export default {
  name: 'main-sidebar',
  props: {
    /**
      * Whether to hide the logo text, or not.
      */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sidebarVisible: false,
    };
  },
  created() {
    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    Events.$on('sidebarVisible', sidebarVisible => { this.sidebarVisible = sidebarVisible; });
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
  },
};
</script>

<style lang="scss">
  .main-sidebar {
    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }
  }
</style>
